<template>
  <div style="display: flex;align-items: center;position: relative;">
    <div class="category-filters">
      <div
        v-for="(item,index) in list"
        :key="item.label"
        class="filter-option"
        :class="{ active: item.active }"
        @click="selectCategory(item)"
        :style="{marginRight:index==list.length-1?'20px':0}"
      >
        {{ item.label }}
      </div>
    </div>
    <div class="view-all-wrapper">
      <div
        v-if="list.length>0"
        class="view-all"
        @click="handleViewAll"
      >
        <!-- {{$t('viewAll')}} -->
        <i
          :class="showAllCategory?'el-icon-arrow-up':'el-icon-arrow-down'"
          style="font-weight: bold;font-size: 18px;"
        ></i>
      </div>
    </div>

    <el-dialog
      :title="$t('selectCategory')"
      center
      :visible.sync="showAllCategory"
      :width="isMobile?'90%':'40%'"
      :show-close="false"
      :modal-append-to-body="false"
    >
      <div class="popup-layout">
        <div class="popup-content">
          <div
            v-for="item in list"
            :key="item.label"
            class="category-filter"
            :class="{ active: item.active}"
            @click="selectCategory(item);hideCategoryPopup()"
            :style="{'background': item.active?selectCategoryBg:noSelectCategoryBg}"
          >
            {{ item.label }}
          </div>
        </div>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="showAllCategory = false"
        >
          {{$t('close')}}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
	import { getGoodsCategoryList } from '@/api/cache'

	export default {
		name: 'CategoryList',
		props: {
			expertId: {
				type: Number,
				default: null
			},
			defaultCategory: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				isMobile: window.innerWidth < 768,
				list: [],
				showAllCategory: false,
				noSelectCategoryBg: '#373737',
				selectCategoryBg: '#486AFF'
			}
		},
		methods: {
			//页面初始化方法
			init() {
				if (this.expertId) {
					this.getGoodsCategory();
					var styleConfig = this.$styleManager.getCurrentConfig();
					if (styleConfig) {
						this.noSelectCategoryBg = styleConfig.backgroundColor == '#0B0B0B' ? '#373737' : '#E8E8E9';
					}
					if (styleConfig) {
						this.selectCategoryBg = styleConfig.themeColor;
					}
				}
			},
			//获取商品分类
			async getGoodsCategory() {
				const res = await getGoodsCategoryList(this.expertId);
				this.list = res.data || [];
				if (this.list.length != 0) {
					this.list.map(item => {
						item.label = item.categoryName;
						item.active = false;
					})
					this.list.unshift({
						goodsCount: 1,
						label: this.$t('newArrivals'),
						active: false
					})
					this.list.unshift({
						goodsCount: 1,
						label: this.$t('bestSeller'),
						active: true
					})
					// 分类加载完成后，根据外部传入参数同步激活分类
					this.applyDefaultCategory(this.defaultCategory);
				}
			},
			// 根据分类名称设置当前激活项
			applyDefaultCategory(categoryName) {
				if (!categoryName) {
					return;
				}
				const target = this.list.find(item => item.categoryName === categoryName);
				if (!target) {
					return;
				}
				this.selectCategory(target);
			},
			// 选择分类
			selectCategory(category) {
				this.list.map(item => {
					item.active = false;
				})
				category.active = true;
				this.$forceUpdate();
				this.$emit('category-selected', category);
			},
			// 处理查看全部
			handleViewAll() {
				this.showAllCategory = !this.showAllCategory;
			},
			// 隐藏分类弹窗
			hideCategoryPopup() {
				this.showAllCategory = false;
			},
		},
		watch: {
			// 监听外部分类变化，支持路由参数变化后同步分类状态
			defaultCategory(value) {
				this.applyDefaultCategory(value);
			}
		}
	}
</script>

<style scoped>
	:deep .el-dialog--center .el-dialog__body {
		padding: 0 20px;
	}

	.view-all-wrapper {
		position: relative;
		display: flex;
		flex-direction: column;
		align-items: center;
		box-shadow: -10px -1px 10px var(--background-color);
		position: absolute;
		right: 0;
		z-index: 99;
		padding: 5px 0;
	}

	.caret-top {
		font-size: 30px;
		color: var(--pupop-bg-color);
		z-index: 1001;
		position: absolute;
		top: -20px;
		right: 35px;
	}

	.category-filters {
		display: flex;
		flex-wrap: nowrap;
		overflow-x: auto;
		padding: 10px 0;
		/* 默认隐藏滚动条 */
		scrollbar-width: thin;
		scrollbar-color: transparent transparent;
		position: relative;
		z-index: 10;
		width: 100%;
		max-width: 1100px;
	}

	/* 鼠标移入时显示滚动条 */
	.category-filters:hover {
		scrollbar-color: #fff transparent;
	}

	.filter-option {
		padding: 20px 30px 10px 30px;
		margin-right: 10px;
		color: var(--link-color);
		cursor: pointer;
		font-size: 17px;
		flex-shrink: 0;
		white-space: nowrap;
		position: relative;
		z-index: 9998 !important;
		/* 确保分类过滤器不会裁剪下拉菜单 */
		overflow: visible !important;
	}

	.filter-option.active {
		font-weight: bold;
		color: var(--primary-color);
		border-bottom-width: 2px;
		border-bottom-style: solid;
		border-bottom-color: var(--primary-color);
	}

	.category-filter {
		padding: 10px 20px;
		border-radius: 10px;
		color: var(--link-color);
		cursor: pointer;
		font-size: 17px;
		transition: all 0.3s ease;
		flex-shrink: 0;
		white-space: nowrap;
		position: relative;
		z-index: 9998 !important;
		/* 确保分类过滤器不会裁剪下拉菜单 */
		overflow: visible !important;
	}

	.category-filter.active {
		font-weight: bold;
		color: #fff;
		background: var(--primary-color);
	}

	/* 悬浮弹窗包装器 */
	.popup-wrapper {
		position: absolute;
		top: 100%;
		left: 100%;
		transform: translateX(-100%);
		z-index: 11;
		margin-top: 20px;
	}

	/* 悬浮弹窗样式 */
	.popup-layout {
		max-height: 300px;
		overflow-y: auto;
		/* 滚动条美化 */
		scrollbar-width: thin;
	}

	.popup-content {
		gap: 10px;
		padding: 15px 0;
		display: flex;
		align-items: center;
		flex-wrap: wrap;
	}

	.view-all {
		text-align: center;
		width: 60px;
		cursor: pointer;
		color: var(--primary-color);
		font-weight: bold;
	}

	/* 响应式调整 */
	@media (max-width: 1200px) {
		.category-filters {
			max-width: calc(100% - 40px);
		}
	}

	@media (max-width: 768px) {
		.category-filters {
			gap: 10px;
			padding: 5px 0;
			max-width: calc(100% - 50px);
		}

		.filter-option {
			padding: 6px 12px;
			font-size: 15px;
		}

		.popup-content {
			padding: 0;
		}

		.view-all {
			width: 50px;
			font-size: 15px;
		}

		.popup-wrapper {
			left: auto;
			right: 0;
			transform: none;
			margin-top: 15px;
		}
	}

	@media (max-width: 480px) {
		.category-filter {
			font-size: 15px;
			padding: 5px 10px;
		}

		.caret-top {
			top: -16px;
		}

		.container {
			padding: 0 10px;
		}

		.filter-option {
			padding: 4px 8px;
			font-size: 15px;
		}

		.view-all {
			width: 50px;
			font-size: 15px;
		}

		.caret-top {
			font-size: 24px;
		}
	}
</style>